<div class="appwidget" #divcontainer>
  <button mat-raised-button class="resetButton" (click)="reset($event)">
    <mat-icon>replay</mat-icon>
  </button>

  <div class="widget" *ngIf="isSmallView">
    <qrcode *ngIf="qrData" id="qrcode" 
      [elementType]="'img'" 
      [qrdata]="qrData" 
      [errorCorrectionLevel]="'M'">
    </qrcode>
  </div>
</div>

<div class="text-editor-wrapper">
  <div class="recognized-text"></div>
  <canvas class="text-editor" id="texteditor" style="pointer-events: none"></canvas>
</div>
